/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationCandidateProfileSettingsShow } from '../../axios/organisationCandidateProfileSettingsShow'
import type {
	OrganisationCandidateProfileSettingsShowError,
	OrganisationCandidateProfileSettingsShowPathParams,
	OrganisationCandidateProfileSettingsShowResponse,
} from '../../types/OrganisationCandidateProfileSettingsShow'

export const organisationCandidateProfileSettingsShowQueryKey = (
	organisation: OrganisationCandidateProfileSettingsShowPathParams['organisation'],
) => [{ url: '/organisations/:organisation/candidate-profile-settings', params: { organisation } }] as const

export type OrganisationCandidateProfileSettingsShowQueryKey = ReturnType<
	typeof organisationCandidateProfileSettingsShowQueryKey
>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationCandidateProfileSettingsController.php OrganisationCandidateProfileSettingsController::show */
export function organisationCandidateProfileSettingsShowQueryOptions(
	organisation: OrganisationCandidateProfileSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationCandidateProfileSettingsShowResponse,
		AxiosError<OrganisationCandidateProfileSettingsShowError>,
		OrganisationCandidateProfileSettingsShowResponse,
		OrganisationCandidateProfileSettingsShowQueryKey
	>({
		queryKey: organisationCandidateProfileSettingsShowQueryKey(organisation),
		queryFn: ({ signal }) =>
			organisationCandidateProfileSettingsShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationCandidateProfileSettingsController.php OrganisationCandidateProfileSettingsController::show */
export function useOrganisationCandidateProfileSettingsShow<
	TSelectData = OrganisationCandidateProfileSettingsShowResponse,
>(
	organisation: OrganisationCandidateProfileSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationCandidateProfileSettingsShowResponse,
					AxiosError<OrganisationCandidateProfileSettingsShowError>,
					TSelectData,
					OrganisationCandidateProfileSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationCandidateProfileSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationCandidateProfileSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationCandidateProfileSettingsController.php OrganisationCandidateProfileSettingsController::show */
export function useOrganisationCandidateProfileSettingsShowSuspense<
	TSelectData = OrganisationCandidateProfileSettingsShowResponse,
>(
	organisation: OrganisationCandidateProfileSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationCandidateProfileSettingsShowResponse,
					AxiosError<OrganisationCandidateProfileSettingsShowError>,
					TSelectData,
					OrganisationCandidateProfileSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationCandidateProfileSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationCandidateProfileSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
